//Package
import { defineComponent } from "vue";

// Components
import Typography from "@/components/general/Typography";

// Assets
import IconCirculeCheck from "@/assets/images/icons/Steps/IconCirculeCheck";
import IconCirculeUser from "@/assets/images/icons/Steps/IconCirculeUser";
import IconCirculeDocument from "@/assets/images/icons/Steps/IconCirculeDocument";
import IconCirculeControl from "@/assets/images/icons/Steps/IconCirculeControl";
import IconCirculeUpdate from "@/assets/images/icons/Steps/IconCirculeUpdate";
import IconCirculeRisk from "@/assets/images/icons/Steps/IconCirculeRisk";
import IconCirculeDefendant from "@/assets/images/icons/Steps/IconCirculeDefendant";

export default defineComponent({
  props: {
    step: {
      type: String | Number,
      required: true,
      default: 0,
    },
    list: {
      type: Array,
      required: true,
      default: ()=>[],
    },
  },
  components: {
    Typography,
    IconCirculeCheck,
    IconCirculeUser,
    IconCirculeDocument,
    IconCirculeControl,
    IconCirculeUpdate,
    IconCirculeRisk,
    IconCirculeDefendant,
  },
  computed: {
    cssProps() {
      return {'--porcent': ((this.step + 1) / this.list.length * 100) + '%'}
    }}
})
